import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link", "panel"];

  connect() {
    console.log("Slider Controller Connected");
  }

  change(event) {
    const index = event.params.index;
    this.linkTargets.forEach(this.deactivate);

    this.activate(event.currentTarget);

    this.panelTargets.forEach((panel, i) => {
      if (i === index) {
        panel.classList.remove("opacity-60");
      } else {
        panel.classList.add("opacity-60");
      }
      panel.style.transform = `translateX(-${100 * index}%)`;
    });
  }

  deactivate(link) {
    const div = link.querySelector("div");
    const h3 = link.querySelector("h3");

    div.classList.remove("bg-teal-600");
    div.classList.add("bg-slate-600");

    h3.classList.remove("text-teal-600");
    h3.classList.add("text-slate-600");
  }

  activate(link) {
    const div = link.querySelector("div");
    const h3 = link.querySelector("h3");

    div.classList.add("bg-teal-600");
    div.classList.remove("bg-slate-600");

    h3.classList.add("text-teal-600");
    h3.classList.remove("text-slate-600");
  }
}
